import { employeeStatusOptions } from 'modules/core/components/EmployeeMultiFilters/commonOptions'
import {
  jobCatalogTitleOptions,
  jobTitleOptions,
  legalEntityOptions,
  locationOptions,
  teamOptions,
} from 'modules/core/components/MultiFilters/commonOptions'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'

export enum Fields {
  EmployeeStatus = 'employee_status',
  EmployeeName = 'employee_name',
  Location = 'location',
  Team = 'team',
  LegalEntity = 'legal_entity',
  UserType = 'user_type',
  JobTitle = 'job_title',
  JobRole = 'job_role',
}

const filterFields: (fieldsToHide: Fields[]) => Promise<FilterOption[]> = async (fieldsToHide) => {
  const fields: FilterOption[] = []

  if (!fieldsToHide.includes(Fields.EmployeeStatus)) {
    fields.push({
      label: i18n.t('filters.multi_filters.employee_status'),
      value: Fields.EmployeeStatus,
      type: 'equal_choice',
      options: await employeeStatusOptions(),
    })
  }

  if (!fieldsToHide.includes(Fields.EmployeeName)) {
    fields.push({
      label: i18n.t('filters.multi_filters.employee'),
      value: Fields.EmployeeName,
      type: 'string',
    })
  }

  if (!fieldsToHide.includes(Fields.Location)) {
    fields.push({
      label: i18n.t('filters.multi_filters.location'),
      value: Fields.Location,
      type: 'single_choice',
      options: await locationOptions(),
    })
  }

  if (!fieldsToHide.includes(Fields.Team)) {
    fields.push({
      label: i18n.t('filters.multi_filters.team'),
      value: Fields.Team,
      type: 'single_choice',
      options: await teamOptions(),
    })
  }

  if (!fieldsToHide.includes(Fields.LegalEntity)) {
    fields.push({
      label: i18n.t('filters.multi_filters.legal_entity'),
      value: Fields.LegalEntity,
      type: 'single_choice',
      options: await legalEntityOptions(),
    })
  }

  if (!fieldsToHide.includes(Fields.UserType)) {
    fields.push({
      label: i18n.t('filters.multi_filters.user_types.label'),
      value: Fields.UserType,
      type: 'single_choice',
      options: [
        { label: i18n.t('filters.multi_filters.user_types.external_user'), value: true },
        { label: i18n.t('filters.multi_filters.user_types.employee'), value: false },
      ],
    })
  }

  if (!fieldsToHide.includes(Fields.JobTitle)) {
    fields.push({
      label: i18n.t('filters.multi_filters.job_title'),
      value: Fields.JobTitle,
      type: 'single_choice',
      options: await jobTitleOptions(),
    })
  }

  if (!fieldsToHide.includes(Fields.JobRole)) {
    fields.push({
      label: i18n.t('filters.multi_filters.job_role'),
      value: Fields.JobRole,
      type: 'single_choice',
      options: await jobCatalogTitleOptions(),
    })
  }

  return fields
}
